/**
 * Rich sample event for the portal builder canvas and Liquid preview.
 * Not a real DB record — used when no account event is selected.
 * Keep in sync with Planning::PortalPreviewStub.
 */
export const PORTAL_PREVIEW_STUB_ID = '__portal_preview_stub__';

export const isPortalPreviewStub = id => id === PORTAL_PREVIEW_STUB_ID;

const COVER_URL =
  'https://images.unsplash.com/photo-1540575467063-178a50c2df87?w=1600&h=900&fit=crop';

const PRICE_BREAKDOWN = {
  currency: 'EUR',
  total_incl_tax: 24850,
  total_excl_tax: 20537.19,
  tax_amount: 4312.81,
  line_items: [
    {
      name: 'Grand Ballroom — 2 days',
      quantity: 2,
      unit_price: 4500,
      line_total: 9000,
    },
    {
      name: 'Breakout rooms (×3)',
      quantity: 3,
      unit_price: 800,
      line_total: 2400,
    },
    {
      name: 'Executive catering',
      quantity: 180,
      unit_price: 65,
      line_total: 11700,
    },
    {
      name: 'Full AV package',
      quantity: 1,
      unit_price: 1750,
      line_total: 1750,
    },
  ],
};

const QUOTE_V2_BREAKDOWN = {
  currency: 'EUR',
  total_incl_tax: 24850,
  total_excl_tax: 20537.19,
  tax_amount: 4312.81,
  discount_amount: 500,
  discounts: [
    { label: 'Early bird', code: 'EARLY', type: 'fixed', value: 500 },
  ],
  line_items: [
    {
      name: 'Grand Ballroom — 2 days',
      quantity: 2,
      unit_price: 4500,
      line_total: 9000,
    },
    {
      name: 'Breakout rooms (×3)',
      quantity: 3,
      unit_price: 800,
      line_total: 2400,
    },
    {
      name: 'Executive catering',
      quantity: 180,
      unit_price: 65,
      line_total: 10530,
      adjustment: { type: 'percent', value: -10 },
      adjustment_amount: -1170,
    },
    {
      name: 'Full AV package',
      quantity: 1,
      unit_price: 1750,
      line_total: 1750,
    },
  ],
};

export const PORTAL_PREVIEW_EVENT_STUB = {
  id: PORTAL_PREVIEW_STUB_ID,
  name: 'Acme Leadership Summit 2026',
  description:
    '<p>Join us for two days of strategy, workshops, and networking at our flagship annual summit. Discover product roadmaps, share best practices, and connect with leaders across the Acme network.</p><p>Dress code is business casual. Breakfast and lunch are included on both days.</p>',
  system_stage: 'confirmed',
  custom_status: 'Confirmed',
  pax: 180,
  start_date: '2026-09-18',
  end_date: '2026-09-19',
  quote_url: 'https://example.com/quotes/acme-summit-2026',
  external_quote_url: 'https://example.com/quotes/acme-summit-2026',
  current_total_price: 24850,
  is_stub: true,
  customer: {
    id: 'stub-customer',
    name: 'Acme Corporation',
    email: 'events@acme.inc',
  },
  event_manager: {
    id: 'stub-manager',
    name: 'Sophie Laurent',
    email: 'sophie.laurent@rookoo.app',
    phone: '+32470123456',
    avatar_url:
      'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=200&h=200&fit=crop&crop=face',
  },
  design: {
    cover_url: COVER_URL,
  },
  custom_attributes: {
    dietary_notes: '12 vegetarian, 4 vegan, 2 gluten-free',
    av_package: 'Full AV — stage, mics, live stream',
    catering_menu: 'Executive buffet + coffee breaks',
    security_contact: 'On-site security from 07:00',
    technical_contact: 'AV desk in foyer',
    crew_size: '8 stewards',
    parking: 'Underground P2 — validation at reception',
    wifi: 'AcmeGuest / Summit2026',
  },
  attributes_by_category: {
    catering: {
      'Dietary notes': '12 vegetarian, 4 vegan, 2 gluten-free',
      'Catering menu': 'Executive buffet + coffee breaks',
    },
    av: {
      'AV package': 'Full AV — stage, mics, live stream',
      'Technical contact': 'AV desk in foyer',
    },
    other: {
      'Security contact': 'On-site security from 07:00',
      'Crew size': '8 stewards',
      Parking: 'Underground P2 — validation at reception',
      WiFi: 'AcmeGuest / Summit2026',
    },
  },
  pricing: PRICE_BREAKDOWN,
  metadata: {
    price_breakdown: PRICE_BREAKDOWN,
  },
  quotes: [
    {
      id: 'stub-quote-2',
      name: 'Quote v2',
      version: 2,
      status: 'sent',
      currency: 'EUR',
      total: 24850,
      subtotal: 20537.19,
      tax: 4312.81,
      url: 'https://example.com/quotes/acme-summit-2026-v2',
      signable: true,
      line_items: QUOTE_V2_BREAKDOWN.line_items,
      pricing: QUOTE_V2_BREAKDOWN,
    },
    {
      id: 'stub-quote-1',
      name: 'Quote v1',
      version: 1,
      status: 'viewed',
      currency: 'EUR',
      total: 22100,
      subtotal: 18264.46,
      tax: 3835.54,
      url: 'https://example.com/quotes/acme-summit-2026-v1',
      signable: true,
      line_items: [
        {
          name: 'Grand Ballroom — 2 days',
          quantity: 2,
          unit_price: 4000,
          line_total: 8000,
        },
        {
          name: 'Executive catering',
          quantity: 180,
          unit_price: 60,
          line_total: 10800,
        },
        {
          name: 'Full AV package',
          quantity: 1,
          unit_price: 1500,
          line_total: 1500,
        },
      ],
      pricing: {
        currency: 'EUR',
        total_incl_tax: 22100,
        total_excl_tax: 18264.46,
        tax_amount: 3835.54,
        line_items: [
          {
            name: 'Grand Ballroom — 2 days',
            quantity: 2,
            unit_price: 4000,
            line_total: 8000,
          },
          {
            name: 'Executive catering',
            quantity: 180,
            unit_price: 60,
            line_total: 10800,
          },
          {
            name: 'Full AV package',
            quantity: 1,
            unit_price: 1500,
            line_total: 1500,
          },
        ],
      },
    },
  ],
  active_quote: {
    id: 'stub-quote-2',
    name: 'Quote v2',
    version: 2,
    status: 'sent',
    currency: 'EUR',
    total: 24850,
    subtotal: 20537.19,
    tax: 4312.81,
    url: 'https://example.com/quotes/acme-summit-2026-v2',
    signable: true,
    line_items: QUOTE_V2_BREAKDOWN.line_items,
    pricing: QUOTE_V2_BREAKDOWN,
  },
  allocated_resources: [
    {
      id: 'stub-res-1',
      name: 'Grand Ballroom',
      resource_id: 'stub-resource-ballroom',
      start_at: '2026-09-18T08:00:00Z',
      end_at: '2026-09-19T18:00:00Z',
    },
    {
      id: 'stub-res-2',
      name: 'Foyer A',
      resource_id: 'stub-resource-foyer',
      start_at: '2026-09-18T07:30:00Z',
      end_at: '2026-09-19T18:00:00Z',
    },
  ],
  allocations: [
    {
      id: 'stub-alloc-1',
      title: 'Registration & welcome coffee',
      description: 'Badge pickup in Foyer A',
      start_at: '2026-09-18T08:00:00Z',
      end_at: '2026-09-18T09:00:00Z',
      status: 'confirmed',
      category: 'setup',
    },
    {
      id: 'stub-alloc-2',
      title: 'Opening keynote',
      description: 'CEO welcome and 2026 vision',
      start_at: '2026-09-18T09:00:00Z',
      end_at: '2026-09-18T10:30:00Z',
      status: 'confirmed',
      category: 'session',
    },
    {
      id: 'stub-alloc-3',
      title: 'Workshop tracks',
      description: 'Product, Ops, and Growth breakouts',
      start_at: '2026-09-18T11:00:00Z',
      end_at: '2026-09-18T12:30:00Z',
      status: 'confirmed',
      category: 'session',
    },
    {
      id: 'stub-alloc-4',
      title: 'Networking lunch',
      description: 'Executive buffet in the atrium',
      start_at: '2026-09-18T12:30:00Z',
      end_at: '2026-09-18T14:00:00Z',
      status: 'confirmed',
      category: 'catering',
    },
    {
      id: 'stub-alloc-5',
      title: 'Strategy roundtables',
      description: 'Facilitated peer sessions',
      start_at: '2026-09-19T09:30:00Z',
      end_at: '2026-09-19T12:00:00Z',
      status: 'confirmed',
      category: 'session',
    },
    {
      id: 'stub-alloc-6',
      title: 'Closing reception',
      description: 'Drinks and awards',
      start_at: '2026-09-19T16:00:00Z',
      end_at: '2026-09-19T18:00:00Z',
      status: 'confirmed',
      category: 'catering',
    },
  ],
  event_floorplans: [
    {
      id: 'stub-fp-1',
      space_name: 'Grand Ballroom',
      source_layout_name: 'Theatre 180',
    },
    {
      id: 'stub-fp-2',
      space_name: 'Breakout North',
      source_layout_name: 'U-shape 40',
    },
  ],
  documents: [
    {
      id: 'stub-doc-1',
      name: 'Summit agenda.pdf',
      filename: 'Summit agenda.pdf',
      url: '#',
      content_type: 'application/pdf',
    },
    {
      id: 'stub-doc-2',
      name: 'Venue map.pdf',
      filename: 'Venue map.pdf',
      url: '#',
      content_type: 'application/pdf',
    },
    {
      id: 'stub-doc-3',
      name: 'Speaker bios.pdf',
      filename: 'Speaker bios.pdf',
      url: '#',
      content_type: 'application/pdf',
    },
  ],
};

export default PORTAL_PREVIEW_EVENT_STUB;
